import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './PartnersSlideshow.css';

const PartnersSlideshow = () => {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    const fetchPartners = async () => {
      try {
        const response = await axios.get('http://localhost:5000/partners');
        setPartners(response.data);
      } catch (error) {
        console.error('Error fetching partner images:', error);
      }
    };
    fetchPartners();
  }, []);

  return (
    <div className="partners-slideshow-container">
      <div className="partners-slideshow">
        {partners.map((partner, idx) => (
          <div key={idx} className="partner-slide">
            <img 
              src={partner.image} 
              srcSet={`${partner.image} 1x, ${partner.hdImage || partner.image} 2x`} 
              alt={partner.alt || `Partner ${idx + 1}`} 
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PartnersSlideshow;
